import React, { useState } from "react";
import { PawPrint } from "lucide-react";
import Reveal from "../Reveal";

const serviceOptions = [
  "Wellness Check", "Vaccination Care", "Dental Cleaning", "Nutritional Guidance",
  "Parasite Prevention", "Surgery & Recovery", "Emergency Treatment", "Pet Grooming",
  "Behavioral Consultation", "Senior Pet Care",
];

const doctorOptions = [
  "Dr. Emily Hart", "Dr. Lucas Meyer", "Dr. Chloe Ramirez", "Dr. Nathan Cole", "Dr. Olivia Zhang",
  "Dr. Daniel Rossi", "Dr. Sarah Bennett", "Dr. Ethan Moore",
];

const inputCls =
  "w-full rounded-xl border border-pawelle-ink/12 bg-white px-4 py-3.5 font-body text-[15px] text-pawelle-ink outline-none transition focus:border-pawelle-primary placeholder-pawelle-body/70";

const AppointmentForm = () => {
  const [form, setForm] = useState({
    name: "", pet: "", phone: "", email: "", service: "", doctor: "", date: "", message: "",
  });
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => setSent(false), 4000);
  };

  return (
    <section className="bg-pawelle-primary py-20 md:py-28">
      <div className="mx-auto max-w-[1000px] px-5">
        <div className="mx-auto max-w-2xl text-center">
          <Reveal animation="rubberBand">
            <span className="inline-flex items-center gap-2 font-display text-[15px] font-semibold text-white/85">
              <PawPrint className="h-5 w-5" /> Meet Our Team
            </span>
          </Reveal>
          <Reveal animation="fadeInUp" delay={100}>
            <h2 className="mt-4 font-display text-[30px] font-bold leading-tight text-white md:text-[38px]">
              Schedule Expert Care Tailored to Your Pet's Needs
            </h2>
          </Reveal>
        </div>

        <Reveal animation="fadeInUp" delay={150} className="mt-12 rounded-[28px] bg-white p-6 shadow-[0_30px_70px_rgba(0,0,0,0.15)] md:p-10">
          <form onSubmit={submit} className="grid gap-5 sm:grid-cols-2">
            <input className={inputCls} placeholder="Your Name" value={form.name} onChange={set("name")} required />
            <input className={inputCls} placeholder="Pet Name" value={form.pet} onChange={set("pet")} />
            <input className={inputCls} placeholder="Phone" value={form.phone} onChange={set("phone")} />
            <input className={inputCls} type="email" placeholder="Email" value={form.email} onChange={set("email")} required />
            <select className={`${inputCls} appearance-none`} value={form.service} onChange={set("service")}>
              <option value="">Services</option>
              {serviceOptions.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
            <select className={`${inputCls} appearance-none`} value={form.doctor} onChange={set("doctor")}>
              <option value="">Select Doctor</option>
              {doctorOptions.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
            <input className={inputCls} type="date" placeholder="Date" value={form.date} onChange={set("date")} />
            <input className={inputCls} placeholder="Message" value={form.message} onChange={set("message")} />
            <div className="sm:col-span-2">
              <button
                type="submit"
                className="w-full rounded-xl bg-pawelle-primary px-6 py-4 font-display text-[16px] font-medium text-white transition-all duration-300 hover:bg-pawelle-primary-dark"
              >
                {sent ? "Booking Received!" : "Booking Now"}
              </button>
            </div>
          </form>
        </Reveal>
      </div>
    </section>
  );
};

export default AppointmentForm;
